import { Box } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useTheme } from '@mui/material/styles'
import { DiscoveryDialog } from 'src/components/Dialogs/DiscoveryAssets/DiscoveryDialog'
import { DiscoveryLmnDialog } from 'src/components/Dialogs/DiscoveryAssets/DiscoveryLmnDialog'
import { useState } from 'react'
import mixpanel from 'mixpanel-browser'
import { CDN_PATH } from 'src/constants/global'
import styles from './Chip.scss'

interface ChipProps {
  align?: string
  allWhite?: boolean
  allBlack?: boolean
  isLmn?: false
  merchantUuid?: string
  removeInfoIcon?: boolean
  removeLearnMore?: boolean
  openEventName?: string
}

interface LmnChipProps {
  align?: string
  allWhite?: boolean
  allBlack?: boolean
  isLmn: true
  merchantUuid: string
  removeInfoIcon?: boolean
  removeLearnMore?: boolean
  openEventName?: string
}

type AllChipProps = ChipProps | LmnChipProps

function Chip ({
  align = 'flex-start',
  allWhite,
  allBlack,
  isLmn,
  merchantUuid,
  removeInfoIcon,
  removeLearnMore,
  openEventName,
}: AllChipProps): JSX.Element {
  const { palette } = useTheme()
  const [open, setOpen] = useState(false)
  const [openLmn, setOpenLmn] = useState(false)
  const handleOpen = (): void => {
    if (openEventName) {
      mixpanel.track(openEventName)
    }
    if (isLmn) {
      setOpenLmn(true)
    } else {
      setOpen(true)
    }
  }
  const handleClose = (): void => setOpen(false)
  const handleCloseLmn = (): void => setOpenLmn(false)

  return (
    <>
      <Box
        className={styles.Chip}
        onClick={handleOpen}
        justifyContent={align}
        pb={1}
      >
        { isLmn && !removeLearnMore ? (
          <img className={styles.ChipIconLmn} src={`${CDN_PATH}/images/asset-chip-lmn-learn-more.svg`} alt="HSA | FSA Accepted WITH AN LMN" />
        ) : null }
        { isLmn && removeLearnMore ? (
          <img className={styles.ChipIconLmn} src={`${CDN_PATH}/images/asset-chip-lmn.svg`} alt="HSA | FSA Accepted WITH AN LMN" />
        ) : null }
        { !isLmn && allWhite ? (
          <img className={styles.ChipIcon} src={`${CDN_PATH}/images/asset-chip-white.svg`} alt="HSA | FSA Accepted" />
        ) : null }
        { !isLmn && allBlack ? (
          <img className={styles.ChipIcon} src={`${CDN_PATH}/images/asset-chip-black.svg`} alt="HSA | FSA Accepted" />
        ) : null }
        { !isLmn && !allWhite && !allBlack ? (
          <img className={styles.ChipIcon} src={`${CDN_PATH}/images/asset-chip.svg`} alt="HSA | FSA Accepted" />
        ) : null }
        {removeInfoIcon ? null : (
          <InfoOutlinedIcon className={styles.ChipInfoIcon} sx={{ color: allWhite ? 'white' : palette.primary.main }} fontSize="inherit" />
        )}
      </Box>
      <DiscoveryDialog isOpen={open} onClose={handleClose} />
      <DiscoveryLmnDialog isOpen={openLmn} onClose={handleCloseLmn} merchantUuid={merchantUuid ?? ''} />
    </>
  )
}

export default Chip
